import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';

const RadarLegend = props => {
    const { language } = props;

    return (
        <div className="legend">
            <div className="legend__title">
                {translate(language, 'radar_legend_title')}
            </div>
            <div className="legend__colors" />
            <div className="legend__labels">
                <span>{translate(language, 'radar_feble')}</span>
                <span>{translate(language, 'radar_moderada')}</span>
                <span>{translate(language, 'radar_forta')}</span>
                <span>{translate(language, 'radar_calamarsa')}</span>
            </div>
        </div>
    );
};

RadarLegend.propTypes = {
    language: PropTypes.string,
};

export default RadarLegend;



// WEBPACK FOOTER //
// ./src/partials/RadarLegend.js